<template>
  <section
    class="onboarding-checklist"
    aria-labelledby="onboarding-checklist-title"
  >
    <div class="onboarding-checklist__header">
      <strong id="onboarding-checklist-title">
        {{ $t("onboard.checklist.title") }}
        <span class="onboarding-checklist__separator">·</span>
        <span class="onboarding-checklist__progress"
          >{{ completedCount }}/{{ total }}</span
        >
      </strong>
      <button
        type="button"
        class="onboarding-checklist__hide"
        @click="$store.dispatch('hideOnboarding')"
      >
        {{ $t("onboard.checklist.hide") }}
      </button>
    </div>
    <ul class="onboarding-checklist__steps">
      <li
        v-for="step in steps"
        :key="step.id"
        class="onboarding-checklist__step"
        :class="{
          'is-done': step.done,
          'is-available': !step.done && step.available,
          'is-locked': !step.done && !step.available,
        }"
      >
        <span class="onboarding-checklist__marker" aria-hidden="true">
          <template v-if="!step.done">•</template>
        </span>
        <button
          type="button"
          :disabled="step.done || !step.available"
          @click="runStep(step.id)"
        >
          {{ step.label }}
        </button>
      </li>
    </ul>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import { ONBOARDING_STEPS } from "@/store/modules/onboarding";

// Карточка «Get started · N/3» внизу экрана списков.
//
// Сама ничего не создаёт: пункты открывают те же формы и экраны, что и
// обычный интерфейс, а шаги закрываются общими событиями пользовательских
// действий (@/utils/userActions) — неважно, откуда пользователь пришёл.
export default {
  name: "OnboardingChecklist",
  data: () => ({ total: ONBOARDING_STEPS }),
  computed: {
    ...mapGetters([
      "getOnboardingState",
      "getOnboardingCompletedCount",
      "getOnboardingListExists",
    ]),
    completedCount() {
      return this.getOnboardingCompletedCount;
    },
    steps() {
      const hasList = this.getOnboardingListExists;
      return [
        {
          id: 1,
          label: this.$t("onboard.checklist.createList"),
          done: hasList,
          available: true,
        },
        {
          id: 2,
          label: this.$t("onboard.checklist.addTask"),
          done: this.getOnboardingState.taskDone,
          available: hasList,
        },
        {
          id: 3,
          label: this.$t("onboard.checklist.inviteSomeone"),
          done: this.getOnboardingState.inviteDone,
          available: hasList,
        },
      ];
    },
  },
  methods: {
    runStep(step) {
      if (step == 1) {
        this.$root.$emit("openEditLists", "Lists");
        return;
      }
      const listId = this.getOnboardingState.listId;
      if (!this.getOnboardingListExists) return;
      if (step == 2) {
        // фокус заберёт AddTasks открытого списка, когда смонтируется
        this.$store.dispatch("requestOnboardingTaskFocus", listId);
        this.$router.push(`/project/${listId}`).catch(() => {});
      } else if (step == 3) {
        this.$root.$emit("addRenameProjectAddUser", listId);
      }
    },
  },
};
</script>
